import React, { useState } from "react";
import { usePagosMultiples } from "../../hooks/pagosMultiples/usePagosMultiples";
import GifLoader from "../../components/ui/gifLoader";
import { TableComponent } from "../../components/pagosMultiples/TableComponent";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  Collapse,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { ConceptsAddedComponent } from "../../components/pagosMultiples/ConceptsAddedComponent";
import { CardPay } from "../../components/pagosMultiples/CardPay";
import { SpinnerLoadGenLC } from "../../components/pagosMultiples/SpinnerLoadGenLC";
import { PaymentReceiptView } from "../../components/pagosMultiples/PaymentReceiptView";

const SpinLoader = () => (
  <div className="d-flex flex-column align-items-center justify-content-center vh-100">
    <GifLoader />
  </div>
);

export const PagosMultiples = () => {
  const {
    loader,
    state,
    searchTerm,
    handleSearchTerm,
    filteredConcepts,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    addedConcepts,
    handleConsultConcept,
    handleUpdateQuantity,
    formatter,
    handleRemoveConcept,
    handleInputChange,
    dataLC,
    handleGenLC,
    loaderGenLC,
    handleResetFlujo,
    errorBackend,
    setErrorBackend,
    errors,
    setDataLC
  } = usePagosMultiples();

  const { title, resGenLC } = state;
  const [openAlert, setOpenAlert] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const tieneReciboActivo = Object.keys(resGenLC || {}).length > 0;

  const handleCloseNotification = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenAlert({ open: false, message: "", severity: "" });
  };

  return (
    <>
      {loader ? (
        <SpinLoader />
      ) : (
        <div style={{ padding: "10px 40px" }}>
          <h1>{title}</h1>
          <hr />
          {!tieneReciboActivo ? (
            <>
              <Box sx={{ width: "60%", padding: "5px 0px" }}>
                <TextField
                  sx={{ backgroundColor: "#ffff" }}
                  size="small"
                  fullWidth
                  label="Buscar concepto"
                  value={searchTerm}
                  onChange={(e) => handleSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: "gray" }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="limpiar búsqueda"
                          onClick={() => handleSearchTerm("")}
                          edge="end"
                          size="small"
                        >
                          <DeleteIcon sx={{ color: "gray" }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box sx={{ padding: "5px 0px" }}>
                <TableComponent
                  data={filteredConcepts}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  handleConsultConcept={handleConsultConcept}
                  formatter={formatter}
                  handleUpdateQuantity={handleUpdateQuantity}
                  setNotification={setOpenAlert}
                />
              </Box>

              {(addedConcepts.length > 0 || loaderGenLC) && (
                <Box sx={{ padding: "5px 0px" }}>
                  {loaderGenLC ? (
                    <SpinnerLoadGenLC />
                  ) : (
                    <>
                      <Grid
                        sx={{ marginTop: "1px" }}
                        container
                        spacing={3}
                        alignItems="flex-start"
                      >
                        <Grid item xs={12} md={6} lg={5}>
                          <CardPay
                            dataLC={dataLC}
                            handleInputChange={handleInputChange}
                            errors={errors}
                            setDataLC={setDataLC}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={7}>
                          <Card
                            sx={{
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <CardContent
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                                flexGrow: 1,
                              }}
                            >
                              <Box sx={{ flexGrow: 1, width: "100%" }}>
                                <ConceptsAddedComponent
                                  data={addedConcepts}
                                  handleUpdateQuantity={handleUpdateQuantity}
                                  formatter={formatter}
                                  handleRemoveConcept={handleRemoveConcept}
                                />
                              </Box>
                              <Box sx={{ width: "100%", mt: 2 }}>
                                <Collapse in={Boolean(errorBackend)}>
                                  <Alert
                                    severity="error"
                                    onClose={() => setErrorBackend(null)}
                                    sx={{ mb: 2, borderRadius: "8px" }}
                                  >
                                    <AlertTitle>
                                      <strong>Error de validación</strong>
                                    </AlertTitle>
                                    {errorBackend}
                                  </Alert>
                                </Collapse>

                                <Button
                                  variant="contained"
                                  fullWidth
                                  size="large"
                                  startIcon={<ReceiptLongIcon />}
                                  onClick={() => handleGenLC()}
                                  disabled={addedConcepts.length === 0}
                                  sx={{
                                    backgroundColor: "var(--main-color-vino)",
                                    padding: "12px",
                                    fontWeight: "700",
                                    borderRadius: "8px",
                                    boxShadow:
                                      "0 2px 4px rgba(128, 0, 32, 0.2)",
                                    transition: "all 0.2s ease-in-out",
                                    "&:hover": {
                                      backgroundColor: "var(--main-color-vino)",
                                      boxShadow: "0 6px 16px rgba(128, 0, 32, 0.35)",
                                      transform: "translateY(-3px)",
                                    },
                                    "&:active": {
                                      transform: "translateY(1px)",
                                    },
                                    "&.Mui-disabled": {
                                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                                    },
                                  }}
                                >
                                  Generar línea de captura
                                </Button>
                              </Box>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Box>
              )}
            </>
          ) : (
            <Box sx={{ padding: "5px 0px" }}>
              <Box sx={{ mb: 2 }}>
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={handleResetFlujo}
                  sx={{
                    color: "var(--main-color-vino)",
                    borderColor: "var(--main-color-vino)",
                    "&:hover": {
                      borderColor: "darkred",
                      backgroundColor: "rgba(128, 0, 32, 0.04)",
                    },
                  }}
                >
                  Regresar / Nueva Captura
                </Button>
              </Box>

              <PaymentReceiptView
                responseData={resGenLC}
                formatter={formatter}
              />
            </Box>
          )}
        </div>
      )}

      <Snackbar
        open={openAlert.open}
        autoHideDuration={2500}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={openAlert.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {openAlert.message}
        </Alert>
      </Snackbar>
    </>
  );
};
